module.exports = __webpack_public_path__ + "img/finance-swiper-1.be6b87ef.png";